<template>
  <div v-if="network === 'instagram'" ref="root" class="mt-6 max-w-[19rem]" data-instagram-welcome>
    <p class="text-[0.9rem] leading-[1.6] text-[#f3ede3]/78">
      {{ copy.message }}
    </p>
    <NuxtLink
      :to="target"
      no-prefetch
      class="mt-3 inline-flex min-h-12 items-center justify-center whitespace-nowrap rounded-full border-[3px] border-[#e6d9c3] bg-[#f4ecdf] px-7 py-3 text-center text-[0.72rem] uppercase tracking-[0.26em] text-[#0c0a08] shadow-[0_16px_44px_rgba(0,0,0,0.28)] transition hover:bg-white focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-[#fbf5eb]/80"
      @click="trackClick"
    >
      {{ copy.cta }}
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch, nextTick } from 'vue'
import type { SiteLocaleCode } from '~/utils/locales'

const COPY: Record<SiteLocaleCode, { message: string, cta: string }> = {
  en: { message: 'Welcome from Instagram — join the list to hear about new releases first.', cta: 'Join the list' },
  fr: { message: 'Bienvenue depuis Instagram — rejoignez la liste pour recevoir les nouveautés en premier.', cta: 'Rejoindre la liste' },
  es: { message: 'Te damos la bienvenida desde Instagram — únete a la lista para conocer las novedades antes que nadie.', cta: 'Unirse a la lista' },
  pt: { message: 'Chegou pelo Instagram — entre na lista para saber as novidades primeiro.', cta: 'Entrar na lista' },
  ja: { message: 'Instagramからようこそ — リストに参加して、新作の情報をいち早く受け取ってください。', cta: 'リストに参加' },
  ko: { message: 'Instagram에서 오신 것을 환영합니다 — 리스트에 참여하고 새로운 소식을 가장 먼저 받아보세요.', cta: '리스트 참여' },
  de: { message: 'Willkommen von Instagram — treten Sie der Liste bei und erfahren Sie Neuheiten als Erste.', cta: 'Liste beitreten' },
  it: { message: 'Arrivi da Instagram — entra in lista per conoscere le novità in anteprima.', cta: 'Entrare in lista' },
  zh: { message: '欢迎来自 Instagram — 加入名单，第一时间了解新品。', cta: '加入名单' }
}

const currentLocale = useSiteLocale()
const signalsKit = useSignalsKit()
const { network } = useSocialOrigin()

const copy = computed(() => COPY[currentLocale.value as SiteLocaleCode] || COPY.en)
const target = '#private-access'
const root = ref<HTMLElement | null>(null)

const payload = (interaction: 'view' | 'click') => ({
  interaction_type: interaction,
  cta_label: copy.value.cta,
  cta_location: 'instagram_welcome',
  destination: target,
  social_network: 'instagram',
  locale: currentLocale.value
})

watch(network, async (value) => {
  if (value !== 'instagram') return
  await nextTick()
  signalsKit.trackEditorialSignal('private_access_cta_view', payload('view'))
})

const trackClick = () => {
  signalsKit.trackEditorialSignal('private_access_cta_click', payload('click'))
}
</script>
